import * as Sentry from "@sentry/browser";

export const reportPdfExtractionError = (error: unknown): void => {
  Sentry.captureException(error, { level: "warning", tags: { docScan: "pdfExtraction" } });
};
